import { call, put, takeEvery } from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';
import {
  DELETE_MESSAGE,
  DUPLATE_MESSAGE,
  ERROR_MESSAGE,
  SAVE_MESSAGE
} from '../../../../configs/constants';
import * as MessageActions from '../../../comn/message/actions/comnMessageAction';
import * as Actions from '../actions/basisDronAction';
import * as Apis from '../apis/basisDronApi';

function* listSaga(action: ActionType<typeof Actions.LIST.request>) {
  try {
    const { searchParams } = action.payload;
    const res = yield call(Apis.dronAPI.list, searchParams);
    const {
      data: { items, total },
      count,
      errorCode
    } = res;

    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.LIST.success({
        data: items,
        count,
        total
      })
    );
  } catch (error) {
    yield put(Actions.LIST.failure(error));
  }
}

function* listIdntfSaga(action: ActionType<typeof Actions.IDNTF_LIST.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.dronAPI.idntfList, params);
    const { data, count, errorCode, errorMessage } = res;

    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }

    let dataArr = new Array();

    data?.map(item => {
      dataArr.push({
        ...item,
        isSave: true,
        id: item?.idntfNum,
        idntfNum: item.idntfNum.substring(2)
      });
    });

    yield put(
      Actions.IDNTF_LIST.success({
        data: dataArr,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.IDNTF_LIST.failure(error));
  }
}

function* detailSaga(action: ActionType<typeof Actions.DETAIL.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.dronAPI.detail, id);

    const { data } = res;
    yield put(Actions.DETAIL.success(data));
  } catch (error) {
    yield put(Actions.DETAIL.failure(error));
  }
}

function* createSaga(action: ActionType<typeof Actions.CREATE.request>) {
  try {
    const detail = action.payload;

    const res = yield call(Apis.dronAPI.create, detail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_CREATE.failure(error));
  }
}

function* createIdntfSaga(
  action: ActionType<typeof Actions.IDNTF_CREATE.request>
) {
  try {
    const detail = action.payload;

    const res = yield call(Apis.dronAPI.idntfCreate, detail);
    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      yield put(Actions.IDNTF_CREATE.success(data));
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '식별번호가 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_CREATE.failure(error));
  }
}

function* updateSaga(action: ActionType<typeof Actions.UPDATE.request>) {
  try {
    const detail = action.payload;
    const res = yield call(Apis.dronAPI.update, detail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

function* deleteSaga(action: ActionType<typeof Actions.DELETE.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.dronAPI.delete, id);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: DELETE_MESSAGE.code,
          message: DELETE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_DELETE.failure(error));
  }
}

function* deleteIdntfSaga(
  action: ActionType<typeof Actions.IDNTF_DELETE.request>
) {
  try {
    const id = action.payload;
    const res = yield call(Apis.dronAPI.idntfDelete, id);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: DELETE_MESSAGE.code,
          message: DELETE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      yield put(Actions.IDNTF_DELETE.success(data));
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_DELETE.failure(error));
  }
}

export function* dronSaga() {
  yield takeEvery(Actions.LIST.request, listSaga);
  yield takeEvery(Actions.IDNTF_LIST.request, listIdntfSaga);
  yield takeEvery(Actions.DETAIL.request, detailSaga);
  yield takeEvery(Actions.CREATE.request, createSaga);
  yield takeEvery(Actions.IDNTF_CREATE.request, createIdntfSaga);
  yield takeEvery(Actions.UPDATE.request, updateSaga);
  yield takeEvery(Actions.DELETE.request, deleteSaga);
  yield takeEvery(Actions.IDNTF_DELETE.request, deleteIdntfSaga);
}
